'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mergeOptions = require('merge-options');

var _mergeOptions2 = _interopRequireDefault(_mergeOptions);

var _fuzzysearch = require('fuzzysearch');

var _fuzzysearch2 = _interopRequireDefault(_fuzzysearch);

var _elementScroll = require('./helpers/element-scroll');

var _UiIcon = require('./UiIcon.vue');

var _UiIcon2 = _interopRequireDefault(_UiIcon);

var _UiSelectOption = require('./UiSelectOption.vue');

var _UiSelectOption2 = _interopRequireDefault(_UiSelectOption);

var _UiProgressCircular = require('./UiProgressCircular.vue');

var _UiProgressCircular2 = _interopRequireDefault(_UiProgressCircular);

var _HasTextInput = require('./mixins/HasTextInput');

var _HasTextInput2 = _interopRequireDefault(_HasTextInput);

var _ValidatesInput = require('./mixins/ValidatesInput');

var _ValidatesInput2 = _interopRequireDefault(_ValidatesInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ui-select',

  props: {
    value: {
      type: [Object, Array, String, Number],
      default: null,
      twoWay: true
    },
    default: {
      type: [Object, Array, String, Number],
      default: null
    },
    options: {
      type: Array,
      default: []
    },
    partial: String,
    showSearch: {
      type: Boolean,
      default: false
    },
    searchPlaceholder: {
      type: String,
      default: 'Search'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    multipleDelimiter: {
      type: String,
      default: ', '
    },
    optionsDynamic: {
      type: Boolean,
      default: false
    },
    optionsLoaded: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    keys: {
      type: Object,
      default: function _default() {
        return {
          text: 'text',
          value: 'value',
          image: 'image'
        };
      }
    },
    filter: Function
  },
  data: function data() {
    return {
      query: '',
      selectedIndex: -1,
      highlightedIndex: -1,
      showDropdown: false,
      ignoreQueryChange: false
    };
  },


  computed: {
    filteredOptions: function filteredOptions() {
      if (this.optionsDynamic) {
        return this.options;
      }
      return this.options.filter(this.search);
    },
    displayText: function displayText() {
      var _this = this;

      if (this.multiple && this.value.length) {
        var labels = this.value.map(function (value) {
          return value[_this.keys.text] || value;
        });
        return labels.join(this.multipleDelimiter);
      }
      return this.value ? this.value[this.keys.text] || this.value : '';
    },
    hasDisplayText: function hasDisplayText() {
      return this.displayText && Boolean(this.displayText.length);
    },
    showIcon: function showIcon() {
      return Boolean(this.icon);
    },
    nothingFound: function nothingFound() {
      if (this.optionsDynamic && !this.optionsLoaded) {
        return false;
      }
      if (this.query.length && !this.loading) {
        return !Boolean(this.filteredOptions.length);
      }
      return false;
    }
  },

  watch: {
    filteredOptions: function filteredOptions() {
      this.highlightedIndex = 0;
      (0, _elementScroll.resetScroll)(this.$els.optionsList);
    },
    showDropdown: function showDropdown() {
      if (this.showDropdown) {
        this.opened();
        this.$dispatch('opened');
      } else {
        this.closed();
        this.$dispatch('closed');
      }
    },
    query: function query() {
      if (!this.ignoreQueryChange) {
        this.$dispatch('query-changed', this.query);
      }
    }
  },
  created: function created() {
    this.initValue();
    var errorMessages = {
      min: 'You must select at least :min options.',
      max: 'You must select no more than :max options.',
      between: 'You must select at least :min but no more than :max options.'
    };
    if (this.validationRules) {
      this.validationMessages = (0, _mergeOptions2.default)(errorMessages, this.validationMessages);
    }
  },
  ready: function ready() {
    document.addEventListener('click', this.closeOnExternalClick);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('click', this.closeOnExternalClick);
  },


  events: {
    'ui-select::set-selected': function uiSelectSetSelected(value, id) {
      // Abort if event isn't meant for this component
      if (!this.eventTargetsComponent(id)) {
        return;
      }
      this.default = value;
      this.initValue();
    },
    'ui-input::reset': function uiInputReset(id) {
      // Abort if reset event isn't meant for this component
      if (!this.eventTargetsComponent(id)) {
        return;
      }
      // Reset state
      this.initValue();
      this.dirty = false;
      this.valid = true;

      this.clearQuery();
      this.selectedIndex = -1;
      this.highlightedIndex = -1;
    }
  },
  methods: {
    initValue: function initValue() {
      this.value = this.multiple ? [] : null;
      if (this.default) {
        var defaults = Array.isArray(this.default) ? this.default : [this.default];
        if (defaults.length) {
          this.setDefaultValue(defaults);
        }
      }
    },
    search: function search(option) {
      if (this.filter) {
        return this.filter(option, this.query);
      }
      var query = this.query.toLowerCase();
      var text = option[this.keys.text] || option;
      if (typeof text === 'string') {
        text = text.toLowerCase();
      }
      return (0, _fuzzysearch2.default)(query, text);
    },
    clearQuery: function clearQuery() {
      var _this2 = this;

      this.ignoreQueryChange = true;
      this.$nextTick(function () {
        _this2.query = '';
        _this2.$nextTick(function () {
          _this2.ignoreQueryChange = false;
        });
      });
    },
    select: function select(option, index) {
      var close = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (this.multiple) {
        if (this.isSelected(option)) {
          this.deselect(option);
        } else {
          this.value.push(option);
        }
      } else {
        this.value = option;
        this.selectedIndex = index;
      }
      this.$dispatch('selected', option);
      this.highlightedIndex = index;
      this.clearQuery();
      this.validate();
      if (!this.multiple && close) {
        this.close();
      }
    },
    deselect: function deselect(option) {
      this.value.$remove(option);
    },
    isSelected: function isSelected(option) {
      if (this.multiple) {
        return this.value.indexOf(option) > -1;
      }
      return this.value === option;
    },
    selectHighlighted: function selectHighlighted(index, e) {
      if (this.$refs.options.length) {
        e.preventDefault();
        this.select(this.$refs.options[index].option, index);
      }
    },
    highlight: function highlight(index, preventScroll) {
      if (this.highlightedIndex === index || this.$refs.options.length === 0) {
        return;
      }
      var firstIndex = 0;
      var lastIndex = this.$refs.options.length - 1;
      if (index < firstIndex) {
        index = lastIndex;
      } else if (index > lastIndex) {
        index = firstIndex;
      }
      this.highlightedIndex = index;
      if (!preventScroll) {
        this.scrollOptionIntoView(this.$refs.options[index].$el);
      }
    },
    focus: function focus() {
      this.active = true;
    },
    blur: function blur() {
      this.active = false;
      if (this.showDropdown) {
        this.close();
      }
    },
    toggle: function toggle() {
      if (this.showDropdown) {
        this.close();
      } else {
        this.open();
      }
    },
    open: function open() {
      if (this.disabled) {
        return;
      }
      this.showDropdown = true;
    },
    opened: function opened() {
      var _this3 = this;

      this.$nextTick(function () {
        if (_this3.showSearch) {
          _this3.$els.searchInput.focus();
        } else {
          _this3.$els.dropdown.focus();
        }
        _this3.scrollOptionIntoView(_this3.$els.optionsList.querySelector('.selected'));
      });
    },
    close: function close(deactivate) {
      this.showDropdown = false;
      if (!this.dirty) {
        this.dirty = true;
      }
      if (deactivate) {
        this.active = false;
      } else {
        this.$els.label.focus();
      }
    },
    closeOnExternalClick: function closeOnExternalClick(e) {
      if (!this.$el.contains(e.target) && (this.showDropdown || this.active)) {
        this.close(true);
      }
    },
    closed: function closed() {
      this.validate();
      if (this.multiple) {
        this.highlightedIndex = -1;
      } else {
        this.highlightedIndex = this.selectedIndex;
      }
    },
    setDefaultValue: function setDefaultValue(defaults) {
      var optionValue = void 0;
      var defaultOptionValue = void 0;
      for (var i = 0; i < defaults.length; i++) {
        defaultOptionValue = defaults[i][this.keys.value] || defaults[i];
        for (var j = 0; j < this.options.length; j++) {
          optionValue = this.options[j][this.keys.value] || this.options[j];
          if (optionValue === defaultOptionValue) {
            this.select(this.options[j], j, false);
            break;
          }
        }
      }
    },
    scrollOptionIntoView: function scrollOptionIntoView(optionEl) {
      (0, _elementScroll.scrollIntoView)(optionEl, this.$els.optionsList, 80);
    }
  },
  components: {
    UiIcon: _UiIcon2.default,
    UiSelectOption: _UiSelectOption2.default,
    UiProgressCircular: _UiProgressCircular2.default
  },
  mixins: [_HasTextInput2.default, _ValidatesInput2.default]
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"ui-select\" :id=\"id\" :class=\"{'disabled': disabled, 'invalid': !valid, 'dirty': dirty, 'active': active, 'has-label': !hideLabel, 'icon-right': iconRight}\">\n  <div class=\"ui-select-icon-wrapper\" v-if=\"showIcon\">\n    <ui-icon :icon=\"icon\" class=\"ui-select-icon\"></ui-icon>\n  </div>\n\n  <div class=\"ui-select-content\">\n    <div class=\"ui-select-label\" :tabindex=\"disabled ? null : '0'\" v-el:label=\"\" @focus=\"focus\" @keydown.tab=\"blur\" @click=\"toggle\" @keydown.space.prevent=\"open\" @keydown.enter.prevent=\"open\">\n      <div class=\"ui-select-label-text\" v-text=\"label\" v-if=\"!hideLabel\"></div>\n      <div class=\"ui-select-display\">\n        <div class=\"ui-select-value\" :class=\"{ placeholder: !hasDisplayText }\" v-text=\"hasDisplayText ? displayText : placeholder\"></div>\n          <ui-icon icon=\"arrow_drop_down\" class=\"ui-select-dropdown-icon\"></ui-icon>\n      </div>\n\n      <div class=\"ui-select-dropdown\" tabindex=\"-1\" v-show=\"showDropdown\" v-el:dropdown=\"\" @keydown.esc.prevent=\"close()\" @keydown.tab=\"close()\" @keydown.up.prevent=\"highlight(highlightedIndex - 1)\" @keydown.down.prevent=\"highlight(highlightedIndex + 1)\" @keydown.enter.prevent.stop=\"selectHighlighted(highlightedIndex, $event)\">\n        <div class=\"ui-select-search\" v-if=\"showSearch\" @click.stop=\"\" @keydown.space.stop=\"\">\n          <input class=\"ui-select-search-input\" type=\"text\" v-el:search-input=\"\" :placeholder=\"searchPlaceholder\" v-model=\"query\" autocomplete=\"off\">\n          <ui-progress-circular class=\"ui-select-search-spinner\" :size=\"24\" :stroke=\"4\" :show=\"loading\"></ui-progress-circular>\n        </div>\n        <ul class=\"ui-select-options\" v-el:options-list=\"\">\n          <ui-select-option :option=\"option\" :partial=\"partial\" :show-checkbox=\"multiple\" :keys=\"keys\" @click.stop.prevent=\"select(option, index)\" @mouseover.stop=\"highlight(index, true)\" :highlighted=\"highlightedIndex === index\" :selected=\"isSelected(option)\" v-for=\"(index, option) in filteredOptions\" v-ref:options=\"\"></ui-select-option>\n          <li class=\"ui-select-no-results\" v-if=\"nothingFound\">No results found</li>\n        </ul>\n      </div>\n    </div>\n\n    <div class=\"ui-select-feedback\" v-if=\"showFeedback\">\n      <div class=\"ui-select-error-text\" transition=\"ui-select-feedback-toggle\" v-text=\"validationError\" v-show=\"!hideValidationErrors &amp;&amp; !valid\"></div>\n      <div class=\"ui-select-help-text\" transition=\"ui-select-feedback-toggle\" v-text=\"helpText\" v-else=\"\"></div>\n    </div>\n  </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-571a3dd1", module.exports)
  } else {
    hotAPI.update("_v-571a3dd1", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}